'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdRotateRight = function MdRotateRight(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.1 25.8c1-1.3 1.5-2.7 1.7-4.2h3.4c-0.3 2.4-1.2 4.6-2.7 6.5z m-6.5 4c1.5-0.2 2.9-0.7 4.2-1.7l2.4 2.4c-1.9 1.5-4.2 2.4-6.6 2.7v-3.4z m11.6-11.4h-3.4c-0.2-1.5-0.7-2.9-1.7-4.2l2.4-2.3c1.5 1.9 2.4 4.1 2.7 6.5z m-7.3-9.2l-7.5 7.4v-6.4c-4.8 0.7-8.4 4.9-8.4 9.8s3.6 9.1 8.4 9.8v3.4c-6.6-0.8-11.8-6.4-11.8-13.2s5.2-12.4 11.8-13.2v-5.2z' })
        )
    );
};

exports.default = MdRotateRight;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/rotate-right.js
// module id = 3277
// module chunks = 0